import {NgbDateParserFormatter, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {DateTime} from "luxon";

export class NgbDateMomentParserFormatter extends NgbDateParserFormatter {
  private dateFormat: string;
  constructor() {
    super();
  };

  static Create(dateFormat: string) {
    const ngbDateMomentParserFormatter = new NgbDateMomentParserFormatter();
    ngbDateMomentParserFormatter.dateFormat = dateFormat;
    return ngbDateMomentParserFormatter;
  }

  format(date: NgbDateStruct): string {
    if (date === null) {
      return '';
    }
    const dateTime = DateTime.fromObject({
      year: date.year,
      month: date.month,
      day: date.day
    });
    return dateTime.isValid ? dateTime.toFormat(this.dateFormat) : '';
  }

  parse(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }
    let dateTime = DateTime.fromFormat(value, this.dateFormat);
    return dateTime.isValid ? {
      year: dateTime.year,
      month: dateTime.month,
      day: dateTime.day
    } : null;
  }
}
